import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
// Rutas
import { routing, appRoutingProviders } from './app.routing';
// Componentes//
import { AppComponent } from './app.component';

import { PreloadComponent } from './components/preload/preload.component';

//import { MaterializeModule } from 'angular2-materialize';

import { PagesComponent } from './pages/pages.component';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module
import { Ng2SearchPipeModule } from 'ng2-search-filter'; // importing the module
import { Ng2OrderModule } from 'ng2-order-pipe';





// admin



@NgModule({
  declarations: [
    AppComponent,
    PreloadComponent,
    PagesComponent
  ],
  imports: [
    BrowserModule,
    //MaterializeModule,
    routing,
    FormsModule,
    HttpModule,
    Ng2SearchPipeModule, // including into imports
    Ng2OrderModule, // importing the sorting package here
    NgxPaginationModule,
    ReactiveFormsModule 
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// F:/node/angular/complejidadesFrontend/src/app/app.module.ts